export const formInputColors =
	'border-gray-300 bg-white text-gray-900 dark:border-gray-500 dark:bg-gray-700 dark:text-gray-200'

export const formInputClass = `${formInputColors} block w-full rounded-md border py-2 px-3 text-base shadow-input`

// TODO: Tailwind @layer components { ... } not working
